export enum ChartRangeType {
  Week = "week",
  Month = "month",
  Year = "year",
  Custom = "custom"
}
